import ApplicationComponent from "./ApplicationComponent";
import useFetchApplications from "./useFetchApplications";
import {makeStyles} from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles({
    label: {
        minWidth: "150px",
        maxWidth: "150px",
    },
    applicationIdText: {
        fontWeight: "bold",
        fontSize: "medium",
        color: "rgb(7,19,33)",
    },
    rowHeader: {
        backgroundColor: "deepskyblue"
    },
    heading: {
        padding: "0px",
        verticalAlign: "text-top"
    },
    yeah: {
        alignItems: "normal"
    },
    groupId: {
        fontWeight: "bold",
        fontSize: "medium",
        backgroundColor: "#bdec9d",
        color: "rgb(6,129,2)"
    },
    groupCell: {
        backgroundColor: "ghostwhite"
    },
    link: {
        color: "blue"
    }
});
export default function App(props) {
    const {isLoaded, applications} = useFetchApplications()
    console.log(applications)

    const classes = useStyles()

    return !isLoaded
        ? <div>Loading...</div>
        : ApplicationComponent(applications, classes)

    // return <List component="nav">
    //     <ListItem divider>
    //         <ListItemText secondary="Hello" />
    //         <ListItemText primary="World!" className={classes.label} />
    //     </ListItem>
    // </List>
}

